  <form class="authForm">
    <h3 class="authForm__title">Зарегистрироваться</h3>
    {{{email}}}
    {{{login}}}
    {{{firstName}}}
    {{{lastName}}}
    {{{phone}}}
    {{{password}}}
    {{{repeatPassword}}}
    {{{submitBtn}}}
    {{{signInBtn}}}
  </form>
